import React, { useCallback, useEffect, useState } from 'react';
import axios, { AxiosError } from 'axios';
import styled from 'styled-components';
import { FaChevronLeft } from 'react-icons/fa';
import { useToasts } from 'react-toast-notifications';
import { Container, Loader, Typography } from 'amphitheatre';
import { HiOutlineCheckCircle, HiOutlineXCircle } from 'react-icons/hi';

import { ReturnButton } from './Upload.styled';

const Item = styled.div`
  color: white;
  display: flex;
  align-items: center;
  font-family: 'Lato';
  margin: 1rem 0;
`;

const Icon = styled.div`
  color: green;
  display: flex;
  align-items: center;
  font-size: 1.5rem;
  padding-right: 0.25rem;
`;

const ErrorIcon = styled.div`
  color: red;
  display: flex;
  align-items: center;
  font-size: 1.5rem;
  padding-right: 0.25rem;
`;

const { Header, Paragraph } = Typography;

interface Props {
  files: File[];
  goBack: () => void;
}

const Uploading: React.FunctionComponent<Props> = ({
  files,
  goBack,
}: Props) => {
  const { addToast } = useToasts();
  const [finished, setFinished] = useState<boolean[]>(
    new Array(files.length).fill(false),
  );
  const [errored, setErrored] = useState<boolean[]>(
    new Array(files.length).fill(false),
  );
  const final = finished.map((value, index) => value !== errored[index]);
  const allFinished = final.reduce((prev, curr) => prev && curr, true);

  const memorisedFinish = useCallback(
    (index: number) => {
      finished[index] = true;
      setFinished([...finished]);
    },
    [finished],
  );

  useEffect(() => {
    console.log('IF CALLED TWICE. TT');
    files.forEach((file, index) => {
      const formData = new FormData();
      formData.append(file.name, file);

      axios
        .post('/api/bluequest/submit', formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        })
        .then((res) => {
          memorisedFinish(index);
        })
        .catch((error: AxiosError) => {
          addToast(`${file.name} failed to upload!`, {
            appearance: 'error',
            autoDismiss: true,
          });
          errored[index] = true;
          setErrored([...errored]);
        });
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Container className="content-container" size="lg">
      <ReturnButton disabled={!allFinished} onClick={goBack}>
        <div className="icon">
          <FaChevronLeft />
        </div>
        Back
      </ReturnButton>
      <Header>Uploading</Header>
      <Paragraph>
        Please do not leave this page until we finished uploading.
      </Paragraph>
      {files.map((file, index) => (
        <Item key={file.name}>
          {errored[index] ? (
            <ErrorIcon>
              <HiOutlineXCircle />
            </ErrorIcon>
          ) : finished[index] ? (
            <Icon>
              <HiOutlineCheckCircle />
            </Icon>
          ) : (
            <Loader size={'0.5rem'} />
          )}
          {file.name}
        </Item>
      ))}
    </Container>
  );
};

export default Uploading;
